const initialState = {
  loading: true,
  data: {},
  errors: {},
};

const appointment = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'REQUEST_APPOINTMENT_REQUEST':
    case 'PHASE_APPOINTMENT_DELETE_REQUEST':
      return {
        ...state,
        loading: true,
        errors: {},
      };
    case 'REQUEST_APPOINTMENT_SUCCESS':
      return {
        ...state,
        loading: false,
        data: payload.appointment,
        errors: {},
      };
    case 'REQUEST_APPOINTMENT_FAILURE':
      return {
        ...state,
        errors: payload.errors || {},
        loading: false,
      };
    case 'PHASE_APPOINTMENT_CREATE_FAILURE':
    case 'PHASE_APPOINTMENT_EDIT_FAILURE':
    case 'PHASE_APPOINTMENT_DELETE_FAILURE':
    case 'PHASE_APPOINTMENT_ADD_VALIDATION':
      return {
        ...state,
        errors: payload.errors || {},
        loading: false,
      };
    case 'PHASE_APPOINTMENT_CLEAR_VALIDATION':
      return {
        ...state,
        loading: true,
        errors: {},
      };
    default:
      return state;
  }
};

export default appointment;



// WEBPACK FOOTER //
// ./client/app/reducers/appointment.js